import { connect } from 'react-redux';

import ChannelsAvailability from '../ChannelsAvailability/ChannelsAvailability';
import { setEmailMeBackProductID } from '../../reduck/listingPageCommonData.reduck';
import { getActiveListingPage, getActiveLocationName } from '../../reduck/selectors';


function mapStateToProps(state, ownProps) {
  return {
    pendingLocation: getActiveListingPage(state).productsDeliveriesSearch.searchPending ||
      state.listingPage.locationSearchSetup.resolvingLocation,
    locationName: getActiveLocationName(state),
    isEmailMeBackHidden: state.listingPage.commonData.emailWhenBackFormProductID === ownProps.id
  };
}

export default connect(mapStateToProps, { setEmailMeBackProductID })(ChannelsAvailability);
